"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var grid_1 = require("@rebass/grid");
var styled_components_1 = __importDefault(require("styled-components"));
var DefaultTheme_1 = require("../../themes/DefaultTheme");
var Components_1 = require("../../Components");
exports.ColumnHeader = styled_components_1["default"].h1(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-family: 'Oswald';\n    font-size: ", ";\n    color: hsla(0,0%,100%,.7);\n    display: block;\n    padding-bottom: 10px;\n    border-bottom: 2px solid hsla(0,0%,100%,.4);\n"], ["\n    font-family: 'Oswald';\n    font-size: ", ";\n    color: hsla(0,0%,100%,.7);\n    display: block;\n    padding-bottom: 10px;\n    border-bottom: 2px solid hsla(0,0%,100%,.4);\n"])), DefaultTheme_1.DefaultTheme.Spacing[4]);
var GetWidth = function (width) {
    if (width === "Fourth") {
        return 1 / 4;
    }
    if (width === "Third") {
        return 1 / 3;
    }
    if (width === "Half") {
        return 1 / 2;
    }
    if (width === "Full") {
        return 1;
    }
};
exports.Column = function (props) {
    return (React.createElement(grid_1.Box, { width: [1, GetWidth(props.blok.Width)] },
        props.blok.Header ? (React.createElement(exports.ColumnHeader, null, props.blok.Header)) : (React.createElement(React.Fragment, null)),
        props.blok.Body && props.blok.Body.map(function (blok) { return React.createElement(Components_1.Components(blok.component), { key: blok._uid, blok: blok }); })));
};
var templateObject_1;
